import { connect } from 'react-redux'

import {
  getIdentityActivitiesHistoryItems,
  getIdentityActiveProTrackName,
  getCurrentProTrackProgressDay,
  getIdentityActivitiesHistoryLimit,
  getIdentityActivitiesHistoryPage,
  isOrganizationHasStories,
  isShowFeatureDot,
} from 'store/entities/identity/selectors'

import TimeLineDots from './TimeLineDots'

const mapStateToProps = state => ({
  isStoryActivatedForOrganization: isOrganizationHasStories(state),
  userActivities: getIdentityActivitiesHistoryItems(state),
  proTrackName: getIdentityActiveProTrackName(state),
  currentDay: getCurrentProTrackProgressDay(state),
  limit: getIdentityActivitiesHistoryLimit(state),
  page: getIdentityActivitiesHistoryPage(state),
  isShowFeatureDot: isShowFeatureDot(state),
})

const mergeProps = ({ userActivities, ...stateProps }, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    userActivities,
    positionElement: userActivities.findIndex(
      userActivity => userActivity.actionType === 'did' && !userActivity.hasStory && userActivity.question
    ),
  }
}

export default connect(mapStateToProps, null, mergeProps)(TimeLineDots)
